import React, { useState } from 'react'
import {FileTextOutlined} from '@ant-design/icons';
import { Modal, Space } from 'antd';
import ClientDesc from './ClientDesc';
function ClientCheck(props) {
    const [open,setOpen] = useState(false)

    return (
        <>
            <a onClick={() => {setOpen(true)}}>
                <Space><FileTextOutlined/>{props.byxkh_name}</Space>
            </a>
            <Modal
                open={open}
                okText="提交"
                cancelText="取消"
                onCancel={() => {
                    setOpen(false);
                }}
                onOk={() => {}}
                footer={null}
                width={1200}
            >            
                <ClientDesc
                    byxkh_id={props.byxkh_id}
                />            
            </Modal>
        </>
    )
}

export default ClientCheck